"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncComponent = require("./asyncComponent");

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Dynamic import function for components

var styleItem = {
  flex: "1 0 30%",
  width: "33.33%",
  marginRight: "6px",
  marginLeft: "6px"
};

var RoadRestorationCreateApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/ROW/CreateApplication").then(function (module) {
    return module.default;
  });
});
var RoadRestorationSearchApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/ROW/SearchApplication").then(function (module) {
    return module.default;
  });
});
var RoadRestorationSearchApplicationView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/ROW/SearchApplication/ViewDetails").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSearchApplicationDashboard = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/ROW/Dashboard").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPaymentSummisionKMDA = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/KMDA/PaymentSummisionKMDA").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSearchApplicationKMDA = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/KMDA/SearchApplicationKMDA").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPlannedCuttingDemand = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PlannedCutting/DemandSearch").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingCreateApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/CreateApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingSearchApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/SearchApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/SearchApplication/ViewDetails").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingModifyApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/SearchApplication/ModifyApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingCombinedDemandSeatch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/SearchApplication/CombinedDemandSearch").then(function (module) {
    return module.default;
  });
});

var ChockageSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Chockage/SearchApplication").then(function (module) {
    return module.default;
  });
});

var ChockageView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Chockage/SearchApplication/ViewDetails").then(function (module) {
    return module.default;
  });
});

// Example route configuration
var routes = [{
  path: "egov-civil/citizen/roadRestoration/createApplication",
  component: RoadRestorationCreateApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/searchApplication",
  component: RoadRestorationSearchApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/searchApplication/view",
  component: RoadRestorationSearchApplicationView,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/rowDashboard",
  component: RoadRestorationSearchApplicationDashboard,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/KMDA/paymentSummision",
  component: RoadRestorationPaymentSummisionKMDA,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/KMDA/searchApplication",
  component: RoadRestorationSearchApplicationKMDA,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/plannedCutting/demand",
  component: RoadRestorationPlannedCuttingDemand,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/smallCutting/createApplication",
  component: RoadRestorationSmallCuttingCreateApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/smallCutting/searchApplication",
  component: RoadRestorationSmallCuttingSearchApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/smallCutting/view",
  component: RoadRestorationSmallCuttingDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/smallCutting/modifyApplication",
  component: RoadRestorationSmallCuttingModifyApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/roadRestoration/smallCutting/combinedDemandSeatch",
  component: RoadRestorationSmallCuttingCombinedDemandSeatch,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/chockage/search",
  component: ChockageSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/citizen/chockage/view",
  component: ChockageView,
  needsAuthentication: true
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-civilcitizen/Routes/module-routes.js
// module id = 3532
// module chunks = 1137